import React from "react";
import "../Component/Component.css/GaonSection.css";
import Nagrik from "../Images/nagrik.png";
import Sthapana from "../Images/sthapana.png";
import Kshetraphal from "../Images/kshetraphal.png";



const GaonSection = () => {
  return (
    <div className="gaon-container">
      <h2 className="gaon-title">आमच्या गावाबद्दल</h2>
      <h4 className="gaon-subtitle">स्वच्छ नागठाणे सुंदर नागठाणे</h4>
      <p className="gaon-desc">
       गावातील प्रत्येक नागरिकाचा सहभाग आणि विश्वास हीच आमची ताकद आहे. एकत्र येऊन आपल्या गावाला डिजिटल, स्वच्छ आणि प्रगत बनवू या.
      </p>

      <div className="gaon-cards">
        <div className="gaon-card">
          <img
            src={Nagrik}
            alt="citizens"
          />
          <div className="gaon-card-text">
            <h4>नागरिक</h4>
            <p>६८५०</p>
          </div>
        </div>

        <div className="gaon-card">
          <img
            src={Sthapana}
            alt="establishment"
          />
          <div className="gaon-card-text">
            <h4>स्थापना</h4>
            <p>१९३८</p>
          </div>
        </div>

        <div className="gaon-card">
          <img
            src={Kshetraphal}
            alt="area"
          />
          <div className="gaon-card-text">
            <h4>गावाचे क्षेत्रफळ</h4>
            <p>५५.५५ कि.मी.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GaonSection;
